import React, { useState, useEffect, useRef } from "react";
import { Container } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import pdf from "../../Assets/CV.pdf";
import { AiOutlineDownload } from "react-icons/ai";
import { Document, Page, pdfjs } from "react-pdf";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

function ResumeNew() {
  const preview = useRef(null);
  const [width, setWidth] = useState(null);

  useEffect(() => {
    const observer = new ResizeObserver(([entry]) => {
      setWidth(Math.min(820, Math.floor(entry.contentRect.width)));
    });
    observer.observe(preview.current);
    return () => observer.disconnect();
  }, []);

  return (
    <Container as="main" fluid className="resume-section">
      <Container>
        <div className="section-header section-header-centered resume-header">
          <h1 className="section-heading">Resume</h1>
          <Button
            variant="primary"
            href={pdf}
            target="_blank"
            rel="noreferrer"
            className="primary-button resume-download"
          >
            <AiOutlineDownload />
            &nbsp;Download CV
          </Button>
        </div>

        <div className="resume-preview-shell" ref={preview}>
          <Document
            file={pdf}
            className="d-flex justify-content-center"
            loading={<div className="resume-loading">Loading resume...</div>}
            error={<p className="resume-loading">The preview could not load. Use Download CV to open the PDF.</p>}
            noData={<p className="resume-loading">The preview is unavailable. Use Download CV to open the PDF.</p>}
          >
            {width > 0 && <Page pageNumber={1} width={width} loading="Rendering resume..." />}
          </Document>
        </div>
      </Container>
    </Container>
  );
}

export default ResumeNew;
